import ArrowDropDown from "@website/icons/components/arrow-drop-down";
import { SaleTypePropertiesType } from "@website/ticket-ui/common/components/sale-type-old/types";
import { Radio } from "@website/ui-old/radio";
import { useCallback, useMemo, useState } from "react";

export const useSaleType = (properties: SaleTypePropertiesType) => {
  const { list, name, onChange, value } = properties;
  const [open, setOpen] = useState<boolean>(false);

  const onClickChips = useCallback(() => {
    setOpen(true);
  }, []);

  const onClosePopover = useCallback(() => {
    setOpen(false);
  }, []);

  const chipsText = useMemo(
    () => list.find((item) => item.value === value)?.title || "",
    [list, value]
  );

  return {
    chipsProps: {
      datatestid: "flight-type-chip",
      color: "secondary" as const,
      EndIcon: <ArrowDropDown />,
      text: chipsText,
      onClick: onClickChips,
      variant: "outline" as const,
      selected: true
    },
    popoverProps: {
      onClose: onClosePopover,
      open,
      title: "نوع مسیر",
      datatestid: "flight-type-popover"
    },
    list: list.map((item) => ({
      title: item.title,
      role: "button",
      size: "small" as const,
      "data-testid": "sale-type-item",
      StartAction: (
        <Radio
          checked={item.value === value}
          color="secondary"
          name={name || ""}
          value={item.value}
        />
      ),
      onClick: () => {
        onChange?.(item.value);
        setOpen(false);
      }
    }))
  };
};
